define('presentation/welcome/common/onboardingNavigationManager',[
    'businessServices/onboarding/liveReceptionistOnboardingSingleton',
    'businessServices/router/router',
    'settings/navigationConfiguration'
], function() {
    const _liveReceptionistOnboardingState = require('businessServices/onboarding/liveReceptionistOnboardingSingleton');
    const _navigationConfiguration = require('settings/navigationConfiguration');
    const _router = require('businessServices/router/router');

    let _disposables = [];

    // Set once, at the moment the customer enters the wizard (onboardingSnackbarViewModel's
    // primary action), so "I'll finish this later" can return them to wherever that was
    let _preOnboardingPathname = null;

    const ROUTE_ID__ONBOARDING_WELCOME = _navigationConfiguration.routesById.liveReceptionistOnboardingWelcome.routeId;
    const ROUTE_ID__ONBOARDING_SCHEDULING = _navigationConfiguration.routesById.liveReceptionistOnboardingScheduling.routeId;
    const ROUTE_ID__ONBOARDING_IDENTITY = _navigationConfiguration.routesById.liveReceptionistOnboardingIdentity.routeId;
    const ROUTE_ID__ONBOARDING_AVAILABILITY = _navigationConfiguration.routesById.liveReceptionistOnboardingAvailability.routeId;
    const ROUTE_ID__ONBOARDING_INFORMATION =  _navigationConfiguration.routesById.liveReceptionistOnboardingInformation.routeId;
    const ROUTE_ID__ONBOARDING_DELIVERY = _navigationConfiguration.routesById.liveReceptionistOnboardingDelivery.routeId;
    const ROUTE_ID__ONBOARDING_PROCESSING = _navigationConfiguration.routesById.liveReceptionistOnboardingProcessing.routeId;

    const ONBOARDING_FLOW = {
        routes: [
            () => _constructRoute(ROUTE_ID__ONBOARDING_IDENTITY),
            () => _constructRoute(ROUTE_ID__ONBOARDING_AVAILABILITY),
            () => _constructRoute(ROUTE_ID__ONBOARDING_INFORMATION),
            () => _constructRoute(ROUTE_ID__ONBOARDING_DELIVERY)
        ],
        routeIndexes: {
            [ROUTE_ID__ONBOARDING_IDENTITY]: 0,
            [ROUTE_ID__ONBOARDING_AVAILABILITY]: 1,
            [ROUTE_ID__ONBOARDING_INFORMATION]: 2,
            [ROUTE_ID__ONBOARDING_DELIVERY]: 3
        }
    };

    const _constructRoute = (routeId) => {
        return _navigationConfiguration.routesById[routeId].url;
    };

    const _previousPage = () =>  {
        const flow = _getFlow();
        const routeId = _getRouteId();
        const previousPageUrl = _getPreviousPageUrl();

        if (previousPageUrl !== null) {
            const currentStep = flow.routeIndexes[routeId] + 1;
            const totalSteps = flow.routes.length;
            const newProgress = currentStep / totalSteps * 100;

            _liveReceptionistOnboardingState.setProgressPercentage(newProgress)
                .done(() => {
                    _router.navigate(previousPageUrl);
                });
        }
    };

    const _nextPage = () => {
        const flow = _getFlow();
        const routeId = _getRouteId();
        const nextPageUrl = _getNextPageUrl();

        if (nextPageUrl !== null) {
            const currentStep = flow.routeIndexes[routeId] + 1;
            const totalSteps = flow.routes.length;
            const newProgress = currentStep / totalSteps * 100;

            _liveReceptionistOnboardingState.setProgressPercentage(newProgress)
                .done(() => {
                    _router.navigate(nextPageUrl);
                });
        }
    };

    const _getRouteId = () => {
        return _router.activeInstruction().config.customSettings.routeId;
    };

    const _getFlow = () => {
        return ONBOARDING_FLOW;
    };

    const _isPreviousPageValid = () => {
        return _getPreviousPageUrl() !== null;
    };

    const _isNextPageValid = () => {
        return _getNextPageUrl() !== null;
    };

    const _getPreviousPageUrl = () => {
        const routeId = _getRouteId();
        const previousPageIndex = ONBOARDING_FLOW.routeIndexes[routeId] - 1;
        if (previousPageIndex >= 0) {
            return ONBOARDING_FLOW.routes[previousPageIndex]();
        }

        return null;
    };

    const _getNextPageUrl = () => {
        const routeId = _getRouteId();
        let nextPageIndex = ONBOARDING_FLOW.routeIndexes[routeId] + 1;
        if (nextPageIndex < ONBOARDING_FLOW.routes.length) {
            return ONBOARDING_FLOW.routes[nextPageIndex]();
        }

        return null;
    };

    const _navigateToWelcomePage = () => {
        _router.navigate(_constructRoute(ROUTE_ID__ONBOARDING_WELCOME));
    };

    const _captureEntryPathname = () => {
        _preOnboardingPathname = window.location.pathname;
    };

    const _navigateToPreOnboardingPageOrHome = () => {
        if (_preOnboardingPathname === null) {
            _router.navigate(_navigationConfiguration.homePageUrl);
            return;
        }

        const pathname = _preOnboardingPathname;
        _preOnboardingPathname = null;
        _router.navigate(pathname);
    };

    const _navigateToFlowStartPage = () => {
        _router.navigate(_constructRoute(ROUTE_ID__ONBOARDING_IDENTITY));
    };

    const _navigateToSchedulingPage = () => {
        _router.navigate(_constructRoute(ROUTE_ID__ONBOARDING_SCHEDULING));
    };

    const _navigateToProcessingPage  = () => {
        _router.navigate(_constructRoute(ROUTE_ID__ONBOARDING_PROCESSING));
    };

    const _detached = () => {
        _disposables.forEach(subscription => subscription.dispose());
        _disposables = [];
    };

    const _initialize = () => {

    };

    return function() {
        let self = this;

        self.init = _initialize;
        self.detached = _detached;
        self.getRouteId = _getRouteId;
        self.getFlow = _getFlow;
        self.isPreviousPageValid = _isPreviousPageValid;
        self.isNextPageValid = _isNextPageValid;
        self.navigateToFlowStartPage = _navigateToFlowStartPage;
        self.navigateToWelcomePage = _navigateToWelcomePage;
        self.captureEntryPathname = _captureEntryPathname;
        self.navigateToPreOnboardingPageOrHome = _navigateToPreOnboardingPageOrHome;
        self.navigateToSchedulingPage = _navigateToSchedulingPage;
        self.navigateToProcessingPage = _navigateToProcessingPage;
        self.previousPage = _previousPage;
        self.nextPage = _nextPage;
    };
});
